<template>
<div class="ofp-chart-group">
  <x-y-chart
    :data-config="dataConfig"
    :unit-prop="unitProp"
    :chart-type="chartType"
    :stack-type="stackType"
    download-name="OFP"
    :show-selected-ctrl-btn="false"
    :show-legend="false"
    :click-handler="onOFPItemClick"
    need-resize
    chart-height="auto"
  />

  <div class="iofp-chart-container">
    <e-chart ref="iofp-chart" @initialized="onIopfChartInitialized" @destroy="onIopfChartDestroy" />
  </div>
</div>
</template>

<script>
import BaseStore from '../../../../components/BaseStore'
import ChartStyle from '../../../../components/DataChart/ChartStyle'

import XYChart from '../../../../components/DataChart/XYChart'
import EChart from '../../../../components/Charts/ECharts'

export default {
  name: 'OfpChartGroup',
  extends: BaseStore,
  components: {XYChart, EChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    hourAvgIopfData: {
      required: true
    },
    unitProp: {
      required: true,
      type: String
    },
    top: {
      required: true
    },
    isAuditCompleted: {
    },
    isMultipleIntegral: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    chartType: 'bar',
    stackType: 1
  }),
  computed: {
    unit () {
      return this.dataConfig.dimensions[0][this.unitProp]
    }
  },
  methods: {
    renderIOFPChart (iopfData) {
      let {iofps} = iopfData
      let {factorMap} = this
      let chartOpt = {
        title: {
          text: iopfData.title,
          left: 'center',
          textStyle: {
            fontFamily: ChartStyle.TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true,
          formatter: function (param) {
            let {data, marker, value, seriesName, name} = param[0]
            return `<div style="min-width: 130px;">
              <span style="display: inline-block; margin: 3px; font-weight: bold;">${name}${(data && data.isHaveIntegral) ? '(重积分)' : ''}</span>
              <div style="display: flex;justify-content: space-between;align-items: center;padding: 2px;">
                <span>${marker}${seriesName}</span>
                <span><span style="font-weight: bold;">${value}</span></span>
              </div>
            </div>`
          }
        },
        grid: [{
          top: 40,
          right: 40,
          bottom: 45,
          left: 0,
          containLabel: true
        }],
        xAxis: [{
          type: 'value',
          name: this.unit,
          nameLocation: 'center',
          nameGap: 23,
          axisLine: {
            show: true
          },
          axisLabel: {
            fontSize: ChartStyle.FONT_SIZE,
            fontFamily: ChartStyle.NUMBER_FONT_FAMILY
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          }
        }],
        yAxis: {
          type: 'category',
          data: iofps.map(iofp => factorMap[iofp.factorId].name),
          inverse: true,
          axisLine: {
            show: true
            // lineStyle: AXIS_LINE_STYLE
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            fontSize: ChartStyle.FONT_SIZE,
            fontFamily: ChartStyle.TEXT_FONT_FAMILY
          }
        },
        series: [{
          name: 'iofp',
          type: 'bar',
          barMaxWidth: 30,
          data: iofps.map(el => {
            return {
              isHaveIntegral: el.isHaveIntegral || false,
              value: Number.isFinite(el.iofp) ? Number(el.iofp.toFixed(3)) : el.iofp
            }
          }),
          color: '#9a60b4',
          label: {
            show: true,
            position: 'insideLeft'
          }
        }]
      }

      let iofpChart = this.$refs['iofp-chart']
      iofpChart.resize()
      iofpChart.setOpt(chartOpt)
    },
    onOFPItemClick (param) {
      this.changeLoadStatus(true)

      let {dataTime} = param.data

      this.$api.Data.getStatisticAnalysisVOCsIOFP(this.dataConfig.id, {
        dataTime,
        isAuditCompleted: this.isAuditCompleted,
        isMultipleIntegral: this.isMultipleIntegral,
        unit: this.unit,
        num: Number(this.top)
      }).then(dataList => {
        this.renderIOFPChart({
          title: new Date(dataTime).format('YYYY-MM-DD HH'),
          iofps: dataList
        })
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onIopfChartInitialized () {
      this.initialized = true

      let {hourAvgIopfData} = this

      if (hourAvgIopfData) {
        this.renderIOFPChart(hourAvgIopfData)
      }
    },
    onIopfChartDestroy () {
      this.initialized = false
    }
  },
  watch: {
    hourAvgIopfData (hourAvgIopfData) {
      if (hourAvgIopfData && this.initialized) {
        this.renderIOFPChart(hourAvgIopfData)
      }
    }
  }
}
</script>

<style lang="scss">
.ofp-chart-group {
  display: grid;
  grid-template-columns: auto 38%;
  grid-column-gap: 10px;
  flex: 1 0;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/05OFP/OpfChartGroup.vue